import dayjs from "dayjs";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./UnprocessedOrders.scss";
import {OrderDTO} from "../../../services/ApiClient";

interface IDeleteConfirmModalProps {
  show: boolean;
  numOfOrders: number | undefined;
  cancelHandler: () => void;
  confirmHandler: () => void;
}

export const DeleteConfirmModal = (props: IDeleteConfirmModalProps) => {
  return (
    <Modal
      show={props.show}
      onHide={props.cancelHandler}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {`Are you sure you want to delete the selected ${props.numOfOrders} order(s)?`}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.cancelHandler}>
          Cancel
        </Button>
        <Button variant="primary" onClick={props.confirmHandler}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
